export function isBetweenDates(startDate?: string, endDate?: string): boolean {
  const today = new Date().getTime();

  const start = startDate ? new Date(startDate).getTime() : -Infinity;

  const end = endDate
    ? isDateWithoutTime(endDate)
      ? new Date(new Date(endDate).setHours(23, 59, 59, 999)).getTime()
      : new Date(endDate).getTime()
    : Infinity;

  return today >= start && today <= end;
}

function isDateWithoutTime(date: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(date);
}
